export const BASE_URL = import.meta.env.VITE_API_URL;

export const API_URLS = {
  // ---------------- AUTH ----------------
  AUTH: {
    LOGIN: "/auth/agent/login",
    ADMIN_LOGIN: "/auth/admin/login",
    REGISTER: "/auth/register",
  },

  DASHBOARD: {
    SUMMARY: "/dashboard/",
  },

  // ---------------- ADMINS ----------------
  ADMINS: {
    CREATE: "/admins/",
    CREATE_SUPERADMIN: "/admins/create-superadmin",
  },

  // ---------------- AGENTS / CLIENTS ----------------
  AGENTS: {
    LIST: "/agents",
    OPTIONS: "/agents/agent-options",
    CREATE: "/agents",
    DETAIL: (id) => `/agents/${id}/details`,
    UPDATE: (id) => `/agents/${id}`,
    DELETE: (id) => `/agents/${id}`,
    STATUS: (agentId) => `/agents/${agentId}/status`,

    // scoring
    SCORING_CONFIG: (agentId) => `/agents/${agentId}/scoring-config`,

    // widget-settings
    WIDGET_SETTINGS: (agentId) => `/agents/${agentId}/widget-settings`,


    // Domains
    DOMAINS: (agentId) => `/agents/${agentId}/domains`,
    DOMAIN_UPDATE: (agentId, domain_id) => `/agents/${agentId}/domains/${domain_id}`,
    DOMAIN_DETAIL: (agentId, domain) => `/agents/${agentId}/domains/${domain}`,
  },

  // ---------------- PROPERTIES ----------------
  PROPERTIES: {
    LIST: "/properties",
    ALL_PROPERTIES: "/properties/all-properties",
    ALL_PROPERTIES_OPTIONS:"/properties/all_property-options",
    DETAIL: (id) => `/properties/${id}`,

    CREATE: (agentId) => `/agents/${agentId}/properties`,
    LIST_BY_AGENT: (agentId) => `/agents/${agentId}/properties`,
    AGENT_PROPERTIES_OPTIONS: (agentId)=> `/agents/${agentId}/properties/agent-properties-options`,
    DETAIL_BY_AGENT: (agentId, propertyId) =>
      `/agents/${agentId}/properties/${propertyId}`,
    UPDATE: (agentId, propertyId) =>
      `/agents/${agentId}/properties/${propertyId}`,
    DELETE: (agentId, propertyId) =>
      `/agents/${agentId}/properties/${propertyId}`,
    STATUS: (agentId, propertyId) =>
      `/agents/${agentId}/properties/${propertyId}/status`,
    DELETE_AGENT_BROCHURE_AND_EXTRACT_DATA: (agentId, propertyId) =>
      `/agents/${agentId}/properties/${propertyId}/delete-brochure-and-extract-data`,
    DELETE_AGENT_FLOOR_PLAN_AND_EXTRACT_DATA: (agentId, propertyId) =>
      `/agents/${agentId}/properties/${propertyId}/delete-floor-plan-and-extract-data`,
    EXTRACT_PDF_DATA: "/extract-brochure",
    EXTRACT_FLOOR_PLAN:"/api/extract-floor-plan"
  },

  // ---------------- LEADS ----------------
  LEADS: {
    LIST: "/leads",
    DETAIL: (id) => `/leads/${id}`,
    EXPORT: "/leads/export",
    PROPERTY_LEADS: (propertyId) => `/properties/${propertyId}/leads`,
    RESEND: (id) => `/leads/${id}/re-send`,
    RESET_STATUS: (id) => `/leads/${id}/reset-status`,
  },
};
